import React from 'react';
import Stripe from '../Stripe';
import CardConnect from '../CardConnect';

function CreditCardInput({
  processorType = 'stripe',
  submit, onToken,
  next, nextButtonLabel, ...other
}) {
  let content = <div />;

  if (processorType === 'card_connect') {
    content = <CardConnect {...other} nextButtonLabel={nextButtonLabel} next={next} onToken={onToken} submit={submit} />;
  } else if (processorType === 'stripe') {
    content = <Stripe {...other} nextButtonLabel={nextButtonLabel} next={next} onToken={onToken} submit={submit} />;
  }
  return content;
}

export default CreditCardInput;